/**
 * DCM-362: local-timezone date strings. toISOString() is UTC — a 23:30
 * Toronto date would render as the NEXT day. These helpers use the local
 * calendar parts.
 */
export function localDateString(d: Date = new Date()): string {
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

export function epochToLocalDate(epoch: number): string {
  return epoch ? localDateString(new Date(epoch * 1000)) : '';
}